import { render, staticRenderFns } from "./ViewBook.vue?vue&type=template&id=61adf43e&scoped=true"
import script from "./ViewBook.vue?vue&type=script&lang=js"
export * from "./ViewBook.vue?vue&type=script&lang=js"
import style0 from "./ViewBook.vue?vue&type=style&index=0&id=61adf43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61adf43e",
  null
  
)

export default component.exports